import React from "react";
import get from "lodash.get";
import { getGroupsData } from "../../layout-utils";
import { Loader } from "../../atoms/loader";
import { SubscriptionBlock } from "./subscription-block";
import { DataBlock } from "./data-block";
import "./minimalist.m.css";

export const Minimalist = (props) => {
  const groups = getGroupsData(props.currentPath, props.subscriptions);
  const group = groups?.[0] || {};
  const plans = group?.subscription_plans || [];
  const subscriptionConfig = get(props, ["config", "pagebuilder-config", "subscription", "pageSetting"], {});

  if (!plans?.length || props?.isAccessTypeUserSetLoading) {
    return <Loader data={plans} subscriptionConfig={subscriptionConfig} />;
  } else {
    const enableDarkMode = get(props, ["enableDarkMode"], false);
    const mode = enableDarkMode ? "dark" : "light";

    const sso = get(props, ["config", "pagebuilder-config", "general", "sso"], {});

    return (
      <div styleName={`component-wrapper ${mode}`}>
        <DataBlock subscriptionConfig={subscriptionConfig} mode={mode} group={group} />
        <SubscriptionBlock
          plans={plans}
          subscriptionConfig={subscriptionConfig}
          sso={sso}
          member={props?.member}
          defaultSubscriptionHandler={props?.defaultSubscriptionHandler}
          localizedTime={props?.localizedTime}
          mode={mode}
        />
      </div>
    );
  }
};
